// src/usePageTracking.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;

    if (path.startsWith("/zoopath") || path.startsWith("/zoovirpath")) {
      // Send only to Zoopath property
      ReactGA.send({
        hitType: "pageview",
        page: path,
        trackingId: "G-PB3XXQNPS9",
      });
    } else {
      // Send only to Main property
      ReactGA.send({
        hitType: "pageview",
        page: path,
        trackingId: "G-5DTYE6JYYE",
      });
    }
  }, [location]);
}
